const GRAM_VALUES = [0.5, 1, 2, 3.5, 7, 14, 28];

export const weightValueOptions = () =>
  GRAM_VALUES.map((value) => ({
    label: `${value}g`,
    value: { units: 'g', value },
  }));
